"use strict";
var FromEventPatternObservable_1 = require('./FromEventPatternObservable');
exports.fromEventPattern = FromEventPatternObservable_1.FromEventPatternObservable.create;
//# sourceMappingURL=fromEventPattern.js.map


//////////////////
// WEBPACK FOOTER
// C:/firebase/gbord/~/rxjs/observable/fromEventPattern.js
// module id = ../../../../rxjs/observable/fromEventPattern.js
// module chunks = 3